import * as React from 'react';
import { separatorColor } from '../../../styles/SharedStyles';
import { useThemeContext } from '../../../context';

export interface HorizontalSeparatorProps {
  className?: string;
}

export function HorizontalSeparator({
  className,
}: HorizontalSeparatorProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <div
      style={{
        padding: '0 0 0 0',
        borderBottom: '1px solid',
        borderBottomColor: separatorColor(theme),
      }}
      className={className}
    />
  );
}
